import { render, staticRenderFns } from "./FragmentOgEmbed.vue?vue&type=template&id=8f4aefde&scoped=true"
import script from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
export * from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
import style0 from "./FragmentOgEmbed.vue?vue&type=style&index=0&id=8f4aefde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4aefde",
  null
  
)

export default component.exports